import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action } from 'satcheljs/lib/legacy';
import { loadMoreConversationsFromServer } from './loadMoreConversationsFromServer';
import { loadMoreItemsFromServer } from './loadMoreItemsFromServer';
import { mutatorAction } from 'satcheljs';
import { wrapFunctionForCoreDatapoint } from 'owa-analytics';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';

// WI : #170279
export const onLoadMoreRowsFailed = action('onLoadMoreRowsFailed')(function onLoadMoreRowsFailed(
    tableView: TableView
) {
    tableView.isLoading = false;
    tableView.hasErrorLoadingTable = true;
});

export default wrapFunctionForCoreDatapoint(
    {
        name: 'LoadMoreInMailTable' /* loadMoreInMailTableDatapoint */,
    },
    function loadMoreInMailTable(tableView: TableView): Promise<void> {
        updateTableViewOnLoadMore(tableView);

        if (tableView.tableQuery.listViewType === 1) {
            return loadMoreItemsFromServer(tableView);
        }
        return loadMoreConversationsFromServer(tableView);
    }
);

const updateTableViewOnLoadMore = mutatorAction(
    'updateTableViewOnLoadMore',
    (tableView: TableView) => {
        tableView.isLoading = true;
    }
);
